<span class="cursor-pointer text-shui-text-subtle flex items-center gap-2" id="navbar-language-selector">
    <sh-icon icon="region-language" size="s" class="text-shui-text-subtle"></sh-icon>
    {{ currentLang().toUpperCase() }}
</span>
<sh-popover target="navbar-language-selector" position="bottom">
    @for (language of languages(); track language.code) {
        <sh-menu-item
            [label]="language.label"
            [active]="currentLang() === language.code"
            (click)="changeLanguage(language.code)"
            ><img slot="functions" class="w-5 h-5 rounded-sm" [src]="language.flag" alt="{{ language.code }} Flag"
        /></sh-menu-item>
    }
</sh-popover>
